import { render, staticRenderFns } from "./moreMall.vue?vue&type=template&id=771ffeca&scoped=true"
import script from "./moreMall.vue?vue&type=script&lang=js"
export * from "./moreMall.vue?vue&type=script&lang=js"
import style0 from "./moreMall.vue?vue&type=style&index=0&id=771ffeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ffeca",
  null
  
)

export default component.exports